// import parseNumber from "@tSurya/utilities/parseNumber";
import Color from "color";
import parseInt from "lodash/parseInt";

const STATIC_PATH = "/userfiles/_static/store";

// -- Colors

const swatch = {
    white: "#FFFFFF",
    celtic: "#2E3F2F",
    black: "#323132",
    lightBlack: "#333333",
    lightBrown: "#866A5B",
    green: "#8AD902",
    red: "#D9001B",
    ocean: "#00558e",
    neutralLight: "#F0F2F7",
    neutralMedium: "#CACFDE",
    primaryBlue: "#006ED2",
    secondaryNavyOne: "#134078",
    secondaryNavyThree: "#112945",
    solitude: "#F0F2F7",
    darkCyanBlue: "#112945",
    yellow: "#EDB800",
    lightGreen: "#00B900",
    alertMsgRed: "#ED0000",
    rockBlue: "#9DB1C9",
    londonFog: "#A29D92",

    grey: {
        lighter: "#F6F6F6",
        light: "#F3F5F7",
        base: "#636161",
        dark: "#636363",
        darker: "#323132",
        shade: "#F1F6FB",
        grayShade: "#F2F2F2",
        lightGrey: "#F9F9F9",
        darkGrey: "#F1F2F3",
        brightGrey: "#CCCCCC",
        whisperGrey: "#ebebeb",
    },
};

export const COLORS = {
    white: swatch.white,
    celtic: swatch.celtic,
    black: swatch.black,
    lightBrown: swatch.lightBrown,
    lightBlack: swatch.lightBlack,
    green: swatch.green,
    ocean: swatch.ocean,
    red: swatch.red,
    neutralLight: swatch.neutralLight,
    neutralMedium: swatch.neutralMedium,
    primaryBlue: swatch.primaryBlue,
    secondaryNavyOne: swatch.secondaryNavyOne,
    secondaryNavyThree: swatch.secondaryNavyThree,
    solitude: swatch.solitude,
    darkCyanBlue: swatch.darkCyanBlue,
    yellow: swatch.yellow,
    lightGreen: swatch.lightGreen,
    alertMsgRed: swatch.alertMsgRed,
    rockBlue: swatch.rockBlue,
    lightGrey: swatch.grey.lightGrey,
    lighterGrey: "#B7B7B7",
    darkGrey: swatch.grey.darkGrey,
    brightGrey: swatch.grey.brightGrey,
    whisperGrey: swatch.grey.whisperGrey,
    dark: swatch.grey.dark,
    londonFog: swatch.londonFog,
    darkBlack: "#000000",
    secondaryBtn: "#0D70B7",
    secondaryBg: "#EDF4F8",
    Matterhorn: "#545454",
    selectedButton: "#C67D30",
    carouselBg: "#F8F8F8",
    categoryTitle: "#323132",
    filterCheckboxText: "#545454",
    featuredMobile: "#2C2420",
    floralWhite: "#F8F7F4",
    accordionBorder: "#D5CEBE",
    primary: {
        base: "#323132",
        contrast: "#ffffff",
    },
    secondary: {
        base: "#F4F3F1",
        contrast: "#323132",
    },
    accent: {
        main: "#866A5B",
        contrast: "#FFFFFF",
    },
    tertiary: {
        light: "#676767",
        base: "#ED9C00",
        dark: "#676767",
        contrast: "black",
    },
    success: "#33864F",
    warning: "#EF9600",
    error: "#BE3445",
    darkmagenta: "#323132",
    background: {
        main: swatch.white,
        contrast: "#0E0E0E",
        black: swatch.black,
        grey: "rgba(255, 255, 255, 0.05)",
    },
    border: {
        main: "#E1DDE2",
    },
    disabled: {
        main: "#E5E5E5",
    },
    info: {
        main: "#1C355E",
        contrast: "#FFFFFF",
    },
    text: {
        accent: "#323132",
        disabled: "#C5C5C7",
        main: "#333333",
        link: "#866A5B",
    },
    shadow: {
        light: "rgba(48, 49, 51, 0.05)",
        base: "rgba(48, 49, 51, 0.1)",
    },
    pagination: {
        base: swatch.grey.light,
        hover: Color(swatch.grey.light).darken(0.15).hex(),
    },
    outline: "#1d8ed5",
    grayBg: "rgb(241, 239, 234)",
    lightGrayBg: "rgb(248, 248, 248)",
    golden: "#A07400",
};

// -- Typography

// const fallbackFont = "Poppins";

export const TYPOGRAPHY = {
    fontFamily: {
        title: `'Mulish'`,
        base: `'Mulish'`,
    },
    weight: {
        base: 400,
        baseBold: 500,
        mediumbold: 600,
        bold: 700,
        black: 800,
    },
    size: {
        veryTiny: "10px",
        vTiny: "11px",
        tiny: "12px",
        smallest: "13px",
        smaller: "14px",
        small: "15px",
        base: "16px",
        large: "18px",
        larger: "20px",
        largest: "24px",
        xlargest: "26px",
        xxlarge: "28px",
        xlarge: "30px",
        xxlargest: "46px",
    },
    lineHeight: {
        smaller: 1,
        small: 1.25,
        large: 2,
        ssmall: "16px",
        msmall: "18px",
        lsmall: "20px",
        base: "22px",
        xbase: "24px",
        medium: "26px",
        lmedium: "28px",
        xmedium: "32px",
        xxmedium: "34px",
        xlmedium: "36px",
        larger: "38px",
        largest: "42px",
        xlargest: "46px",
    },
    spacing: {
        small: "0.5em",
        base: "1em",
        large: "1.5em",
        larger: "2em",
        largest: "3em",
    },
};

// -- Spacings
export const SPACING = {
    xxxlarge: "4em",
    xxlarge: "3em",
    xlarge: "2em",
    large: "1.5em",
    medium: "1.25em",
    standard: "1em",
    small: ".75em",
    xsmall: ".5em",
    xxsmall: ".25em",
    none: "0",
};

// -- Product

const productImageSizes = {
    small: {
        width: 311,
        height: 193,
    },
    medium: {
        width: 690,
        height: 429,
    },
    large: {
        width: 1164,
        height: 724,
    },
};

export const PRODUCT = {
    image: {
        ...productImageSizes,
        ratio: productImageSizes.large.height / productImageSizes.large.width,
    },
};

// -- Common

const contentWidth = 1280;

const spacing = {
    side: ["20px", "30px", "45px", "45px", "45px"],
    content: ["25px", "30px", "45px", "16px", "60px"],
    narrowContent: ["25px", "30px", "40px", "40px", "50px"],
};

const largestSideSpacing = spacing.side.filter(x => x).pop() as any;
const siteWidth = contentWidth + (parseInt(largestSideSpacing) ?? 0) * 2;
// siteWidth = 1280;

export const COMMON = {
    breakpoints: [0, 576, 768, 992, siteWidth],
    width: {
        content: contentWidth,
        site: "100%",
    },
    spacing,
    outline: {
        width: "2px",
        style: "solid",
    },
    defaultProductImagePath: `${STATIC_PATH}/product-not-available.svg`,
    defaultCategoryImagePath: `${STATIC_PATH}/category-not-available.svg`,
};

// -- Menu

export const MENU = {
    mobileButtonSpacing: ".25em",
    topNavItemSpacing: ".8em",
};

// -- Form

export const FORM = {
    field: {
        padding: "1em",
        spacing: "1em",
    },
    button: {
        spacing: "1.6em",
    },
};
